// ==============================|| PAGINATION OVERRIDES ||============================== //


export default function Pagination(theme) {
  return {
    MuiPagination: {
      styleOverrides: {
        root: {
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          fontSize: 18,
          color: theme.palette.grey[500],
          '&.Mui-selected': {
            fontWeight: 700,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.main,
            }
          }
        },
        rounded: {
          borderRadius: 0,
        }
      },
    }
  };
}
